import { AuthMeResponse } from "./auth.types";
import { UserEntity } from "../users/user.types";

// Adapts GET /auth/me's shape to the Redux UserEntity shape: flattens the
// nested `school` object into `school` (name) + `school_id`, and derives
// `uid` from the numeric id (nothing in the app reads UserEntity.uid off
// the auth-hydrated user; it exists for parity with the user-management
// CRUD screens' UserEntity shape).
//
// `school` is null for school-less ADMINs; both flat fields go null then.
export const mapAuthMeToUserEntity = (authMe: AuthMeResponse): UserEntity => ({
  id: authMe.id,
  uid: String(authMe.id),
  first_name: authMe.first_name,
  last_name: authMe.last_name,
  email: authMe.email,
  role: authMe.role,
  school_id: authMe.school?.id ?? null,
  school: authMe.school?.name ?? null,
  showAttendance: authMe.showAttendance,
  // UserEntity.grades keeps `code: string`; normalize the contract's
  // nullable code instead of widening every grades consumer.
  grades: authMe.grades.map((grade) => ({ ...grade, code: grade.code ?? "" })),
});
